import { useFormikContext, useField } from 'formik';
import React__default, { useCallback } from 'react';
import { HappyWebSystemError } from '../base/SystemComponent.js';
import { CheckboxInput } from '../inputs/CheckboxInput.js';
import { onChangeFieldWrapper, hasError } from './Field.js';

/**
 * Checkbox input with Formik field bindings.
 *
 * @example
 * <CheckboxField name="chekkkers" />
 */ const CheckboxField = ({ name , onFieldChange , ...props })=>{
    const context = useFormikContext();
    if (!context) {
        throw new HappyWebSystemError("useFormikContext", "Missing Formik context - CheckboxField must be wrapped by a Formik component.");
    }
    const [field, meta, helpers] = useField({
        name,
        type: "checkbox"
    });
    const { setValue  } = helpers;
    // wrap the onChange to perform side effects if needed
    const onChange = useCallback((v)=>{
        onFieldChange ? onChangeFieldWrapper(onFieldChange, setValue)(v) : setValue(v);
    }, [
        onFieldChange,
        setValue
    ]);
    return React__default.createElement(CheckboxInput, {
        ...props,
        value: field.value,
        checked: !!field.checked,
        hasError: hasError(meta),
        onChange: onChange
    });
};
CheckboxField.dataId = "data-hpy-web-checkbox-field";
CheckboxField.displayName = "CheckboxField";

export { CheckboxField };
